// eslint-disable-next-line no-unused-vars

import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';

import {
  CREATE_PERMISSIONS,
  CREATE_ROLE,
  createPermissionFailed,
  createPermissionSuccess,
  createRoleFailed,
  createRoleSuccess,
  DELETE_ROLE,
  deleteRoleFailed,
  deleteRoleSuccess,
  FETCH_PERMISSIONS,
  FETCH_ROLES,
  fetchPermissionsFailed,
  fetchPermissionsSuccess,
  fetchRolesFailed,
  fetchRolesSuccess,
  UPDATE_ROLE,
  updateRoleFailed,
  updateRoleSuccess,
} from 'actions/rolesAction';

// eslint-disable-next-line no-unused-vars
function* fetchRoles(action) {
  const url = `roles`;
  const authToken = yield select(makeSelectUserToken());
  try {
    const response = yield call(request, url, authToken, {});
    yield put(fetchRolesSuccess(response.roles, response.permissions));
  } catch (err) {
    yield put(fetchRolesFailed(err));
  }
}

// eslint-disable-next-line no-unused-vars
function* fetchPermissions(action) {
  const url = `permissions`;
  const authToken = yield select(makeSelectUserToken());
  try {
    const response = yield call(request, url, authToken, {});
    yield put(fetchPermissionsSuccess(response.pageFolders));
  } catch (err) {
    yield put(fetchPermissionsFailed(err));
  }
}

function* createRole(action) {
  const authToken = yield select(makeSelectUserToken());
  const url = `roles`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, url, authToken, requestOptions);
    yield put(createRoleSuccess(response.role));
  } catch (err) {
    yield put(createRoleFailed(err));
  }
}

function* updateRole(action) {
  const authToken = yield select(makeSelectUserToken());
  const url = `roles/${action.id}`;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, url, authToken, requestOptions);
    yield put(updateRoleSuccess(response.role));
  } catch (err) {
    yield put(updateRoleFailed(err));
  }
}

function* deleteRole(action) {
  const authToken = yield select(makeSelectUserToken());
  const url = `roles/${action.id}`;
  const requestOptions = {
    method: 'DELETE',
  };
  try {
    yield call(request, url, authToken, requestOptions);
    yield put(deleteRoleSuccess(action.id));
  } catch (err) {
    yield put(deleteRoleFailed(err));
  }
}

function* createPermission(action) {
  const authToken = yield select(makeSelectUserToken());
  const url = `permissions`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, url, authToken, requestOptions);

    yield put(createPermissionSuccess(response.pageFolder));
  } catch (err) {
    yield put(createPermissionFailed(err));
  }
}

export default function* rolesSaga() {
  yield all([
    takeLatest(FETCH_ROLES, fetchRoles),
    takeLatest(FETCH_PERMISSIONS, fetchPermissions),
    takeLatest(CREATE_ROLE, createRole),
    takeLatest(CREATE_PERMISSIONS, createPermission),
    takeLatest(UPDATE_ROLE, updateRole),
    takeLatest(DELETE_ROLE, deleteRole),
  ]);
}
